import { createAsyncThunk } from '@reduxjs/toolkit'
import getMemberByClaimKey from '../../api/getMemberByClaimKey'
import REQUEST_STATUS from '../common/REQUEST_STATUS'
import mapEoiPayloadToFormState from '../mapping/mapEoiPayloadToFormState'
import { asyncPendingReducer } from '../common/defaultReducers'

export const fetchMemberByClaimKey = createAsyncThunk(
  'claimKey/fetch',
  async (claimKey) => {
    return await getMemberByClaimKey(claimKey)
  }
)

export const fetchMemberByClaimKeyReducer = {
  [fetchMemberByClaimKey.pending]: (state) => asyncPendingReducer(state),
  [fetchMemberByClaimKey.fulfilled]: (state, action) => {
    mapEoiPayloadToFormState(state, action.payload)
    state.context.appDataRequestStatus = REQUEST_STATUS.SUCCEEDED
    return state
  },
  [fetchMemberByClaimKey.rejected]: (state, action) => {
    state.context.appDataRequestStatus = REQUEST_STATUS.FAILED
    state.error = 'An error occurred, and we may not have received your pre-populated information. You may complete this form manually. If errors persist, please reach out to your HR Manager.'
  }
}